<script setup lang="ts">
import SliderBar from '@/components/common/slidebar.vue'
import { seaTurtleApiClauseInfoGetByTypePost } from '@/services/api/CommonApi'

const { t } = useLang()
useHead({
  title: t('common.b_tdk_title'),
  meta: [
    { name: 'keywords', content: t('common.b_tdk_keywords') },
    { name: 'description', content: t('common.b_tdk_description') },
    { name: 'author', content: t('common.b_author') },
    { name: 'copyright', content: t('common.b_company') },
  ],
})

const categoryId = ref('')
const pageName = ref('')
const pageContent = ref('')

onMounted(() => {
  setTimeout(() => {
    if (process.client) {
      seaTurtleApiClauseInfoGetByTypePost({
        agreementType: 1,
      }).then((res) => {
        pageName.value = res?.showName || ''
        pageContent.value = res?.clauseText || ''
      })
    }
  })
})
</script>

<template>
  <div class="content clearfix">
    <SliderBar path="terms-and-conditions" :category-id="categoryId" />
    <div class="right_main">
      <div class="show_con">
        <div class="title">
          {{ pageName }}
        </div>
        <div class="main_content">
          <p v-html="pageContent" />
          <!-- <ul class="policy_ul">
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title01') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label01_1') }}
                </p>
                <p class="policy_title">
                  {{ t('termsservice.b_label01_2') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title02') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label02_1') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label02_2') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title03') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label03') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title04') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_01') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_02') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_03') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_04') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_05') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_06') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_1') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_2') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_3') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_4') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_5') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_6') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_7') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_8') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_06_9') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_07') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_08') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_08_1') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_08_2') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_08_3') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_08_4') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label04_08_5') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_09') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_10') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label04_11') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title05') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label05') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title06') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label06') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title07') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label07') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label07_1') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label07_2') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label07_3') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label07_4') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label07_5') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label07_6') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title08') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label08') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label08_1') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label08_2') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title09') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label09_1') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label09_2') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label09_3') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label09_4') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label09_4_1') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label09_4_2') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label09_4_3') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title10') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label10_1') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label10_2') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label10_3') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label10_4') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label10_5') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label10_5_1') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label10_5_2') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label10_5_3') }}
                </p>
                <p class="policy_more">
                  {{ t('termsservice.b_label10_5_4') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title11') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label11') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title12') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label12') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title13') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label13') }}
                </p>
              </div>
            </li>
            <li>
              <p class="policy_ask">
                {{ t('termsservice.b_title14') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label14') }}
                </p>
              </div>
            </li>
            <li v-if="['zh-hk', 'en-hk'].includes(locale)">
              <p class="policy_ask">
                {{ t('termsservice.b_title15') }}
              </p>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label15_1') }}
                </p>
              </div>
              <div class="answer_box">
                <p class="policy_title">
                  {{ t('termsservice.b_label15_2') }}
                  <a v-if="pageLink" :href="pageLink" target="_blank" style="color: #409EFF;">[详情]</a>
                </p>
              </div>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import url('@/assets/css/common/index.scss');
</style>
